import React, {useEffect, useRef} from 'react';
import {useUser} from "../../../contexts/UserContext";
import {useApi} from "../../../hooks/UseApi";
import {AssistantVariant, Message} from "../../../models/models";
import {brand} from "../../../theme/brand";
import {AssistantLogo, MessagesContainer,} from './ChatMessages.styled';
import {MessageSystemAuthor, MessageSystemHeader,} from "../MessagesList/MessagesList.styled";
import MessagesList from "../MessagesList";
import AssistantMessage from "../AssistantMessage";

interface ChatMessagesProps {
    messages?: Message[];
    streamingMessage?: Message | null;
    isGenerating?: boolean;

    onRetry?: () => void;
    onRetryNewChat?: () => void;
    canRetry?: boolean;

    variants?: AssistantVariant[];
    onActivateVariant?: (assistantMessageId: number) => void;
    canNavigateVariants?: boolean;

    exportToPdf?: () => Promise<void>;
}

const ChatMessages = ({
    messages,
    streamingMessage,
    isGenerating,
    onRetry,
    onRetryNewChat,
    canRetry = true,
    variants = [],
    onActivateVariant,
    canNavigateVariants = true,
    exportToPdf,
}: ChatMessagesProps) =>
{
    const {user} = useUser();
    const {downloadDocumentForId} = useApi();

    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [streamingMessage]);

    if (messages?.length === 0) {
        return null;
    }

    return (
        <MessagesContainer>
            <MessagesList
                user={user}
                messages={messages}
                variants={variants}
                isGenerating={isGenerating}
                onRetry={onRetry}
                onRetryNewChat={onRetryNewChat}
                canRetry={canRetry}
                onActivateVariant={onActivateVariant}
                canNavigateVariants={canNavigateVariants}
                downloadDocumentForId={downloadDocumentForId}
                exportToPdf={exportToPdf}
            />

            {streamingMessage && (
                <div>
                    <AssistantMessage
                        hasAttachment={false}
                        isLoading={!!streamingMessage.isLoading}
                        isGenerating={!!isGenerating}
                        isError={false}
                        errorText=""
                        thinkingText={streamingMessage.thinking}
                        responseText={streamingMessage.text}
                        citations={[]}
                        openCitationIndex={null}
                        toggleCitation={() => { return; }}
                    />
                    <MessageSystemHeader>
                        <MessageSystemAuthor>
                            <AssistantLogo src={brand.logo} alt="Logo"/>
                        </MessageSystemAuthor>
                    </MessageSystemHeader>
                </div>
            )}

            <div ref={bottomRef} />
        </MessagesContainer>
    );
};

export default ChatMessages;

